// extracted by mini-css-extract-plugin
export default {"title":"_27ePNby0","subtitle":"_3z4PHgzi"};